import * as React from "react";
import {Fragment} from "react";
import JobUserMentionNotification from "../../../model/notification/mention/JobUserMentionNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: JobUserMentionNotification
}

/**
 * Job mention notification toast body.
 */
const NotificationJobUserMentionBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Job {props.notification.data.referenceNumber}</div>
			<div className={"toast-body"}>
				You are mentioned in <strong>{props.notification.data.referenceNumber}</strong>
			</div>
		</Fragment>
	);
};

export default NotificationJobUserMentionBody;